import type { ForwardedRef } from 'react';
import { forwardRef } from 'react';

import type { SkeletonProps } from '@mui/material/Skeleton';
import Skeleton from '@mui/material/Skeleton';

type TRef = HTMLSpanElement | null;

const TempSkeleton = (props: SkeletonProps, ref: ForwardedRef<TRef>) => {
  const { variant = 'rectangular' } = props;

  return (
    <Skeleton
      ref={ref}
      sx={{
        borderRadius: variant === 'circular' ? '50%' : '0.25rem',
        '&:after': { background: 'linear-gradient(90deg, transparent, rgb(199 199 199 / 50%), transparent)' },
      }}
      animation="wave"
      variant={variant}
      {...props}
    />
  );
};

const AtpSkeleton = forwardRef<TRef, SkeletonProps>(TempSkeleton);
export default AtpSkeleton;
